import { getUserId } from "@/src/utils/utils";

import {
    Reference,
    referenceCategories,
    ReferenceCategory
} from "@/src/data/allTypes";

import { openDrawer } from "@/src/components/dialogs";
import { Input } from "@/src/components/universalInput";
import apiFetch from "@/src/utils/apiFetch";
import { useState } from "react";

export function AiReferenceForm({
  currentCategory,
  currentPrompt,
  allowedCategoriesIds,
  onCategoryChange,
  onPromptChange,
}: {
  currentCategory: ReferenceCategory;
  currentPrompt: string | null | undefined;
  allowedCategoriesIds?: ReferenceCategory[];
  onCategoryChange: (category: ReferenceCategory) => void;
  onPromptChange: (prompt: string) => void;
}) {
  const [category, setCategory] = useState(currentCategory);
  const [prompt, setPrompt] = useState(currentPrompt);

  return (
    <div className="grid c1 gap10">
      <Input
        name={""}
        type="select"
        options={[
          { id: null, name: "Tous" },
          ...Object.values(referenceCategories).filter((category) =>
            allowedCategoriesIds?.includes(category.id)
          ),
        ]}
        value={category}
        onChange={(newValue) => {
          setCategory(newValue as ReferenceCategory);
          onCategoryChange(newValue as ReferenceCategory);
        }}
      />
      <Input
        name={"Prompt"}
        type={"textarea"}
        value={prompt}
        rows={30}
        onChange={(newValue) => {
          setPrompt(newValue);
          onPromptChange(newValue);
        }}
      />
    </div>
  );
}

export async function openAiReferenceForm({
  currentPrompt,
  currentCategory,
  allowedCategoriesIds,
  onSave,
}: {
  currentPrompt: string | null | undefined;
  currentCategory: ReferenceCategory;
  allowedCategoriesIds?: ReferenceCategory[];
  onSave: (newValue: Reference) => void;
}) {
  await openDrawer({
    id: "aiReferenceDialog",
    title: `Générer un formulaire par IA`,
    additionalClasses: ["big"],
    content: (
      <AiReferenceForm
        currentCategory={currentCategory}
        currentPrompt={currentPrompt}
        allowedCategoriesIds={allowedCategoriesIds}
        onCategoryChange={(category) => {
          currentCategory = category;
        }}
        onPromptChange={(prompt) => {
          currentPrompt = prompt;
        }}
      />
    ),
    onConfirm: async () => {
      let inserted = await apiFetch("references", "generateAiReference", {
        category: currentCategory,
        prompt: currentPrompt,
        creatorId: getUserId(),
      });
      onSave(inserted);
    },
  });
}
